import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { memo } from 'react'

import { formatToDateDisplay } from '../../../../utilities/date'
import { Select, Space, Typography } from '../../atoms'
import Icon from '../../atoms/Icon'
import AttributeAlt from '../../molecules/attribute-alt/attribute-alt'
import IconLabel from '../../molecules/iconLabel'
import {
  StyledAttributesStack,
  StyledContainer,
  StyledTableContainer
} from './funds-finswitch-reinvestment.styles'

export type FundsFinSwitchReinvestmentProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  confirmationId: string
  mappedExDate: string
  onDateSelection?: (selectedDate: string) => void
  reinvestmentDate: string
  units: number
  upcomingDates: string[]
}

const FundsFinSwitchReinvestmentInner = ({
  mappedExDate,
  onDateSelection,
  reinvestmentDate,
  units,
  upcomingDates
}: FundsFinSwitchReinvestmentProps) => (
  <StyledContainer>
    <Space p={5}>
      <IconLabel
        icon={<Icon name="toggleDown" size="small" />}
        iconPosition="left"
        text="New Finswitch reinvestment units received"
        variant="sh3"
      />
    </Space>
    <StyledTableContainer px={3}>
      <TableContainer classes={{ root: 'Q-Hub' }}>
        <Table aria-label="finswitch-reinvestments">
          <TableBody>
            <TableRow key="finswitch_message">
              <TableCell>
                <Typography variant="b3">
                  This new Finswitch reinvestments data can only be applied to an Ex-Date with
                  submitted distribution data
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow key="upcoming_dates">
              <TableCell>
                <Space isflex flex-flexDirection="row" justifyContent="space-between" my={-1}>
                  <Space pt={1}>
                    <Typography variant="b3">
                      Apply this instruction to an upcoming Ex-Date
                    </Typography>
                  </Space>
                  <Select
                    padding="5px"
                    value={mappedExDate ?? ''}
                    width="300px"
                    onChange={v => onDateSelection(v.target.value)}
                  >
                    <option value="">Choose an Ex-Date</option>
                    {upcomingDates &&
                      upcomingDates.map(c => (
                        <option key={c} value={c}>
                          {formatToDateDisplay(c)}
                        </option>
                      ))}
                  </Select>
                </Space>
              </TableCell>
            </TableRow>
            <TableRow key="finswitch_units">
              <TableCell>
                <StyledAttributesStack isflex flex-flexDirection="row" justifyContent="flex-start">
                  <AttributeAlt label="Number of units" value={units.toString()} />
                  <AttributeAlt
                    label="Reinvestment date"
                    value={formatToDateDisplay(reinvestmentDate)}
                  />
                </StyledAttributesStack>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </StyledTableContainer>
  </StyledContainer>
)

const areEqual = (
  prevProps: FundsFinSwitchReinvestmentProps,
  nextProps: FundsFinSwitchReinvestmentProps
) => {
  if (
    prevProps.mappedExDate === nextProps.mappedExDate &&
    prevProps.confirmationId === nextProps.confirmationId &&
    prevProps.reinvestmentDate === nextProps.reinvestmentDate &&
    prevProps.units === nextProps.units &&
    prevProps.upcomingDates?.length === nextProps.upcomingDates?.length
  ) {
    return true
  }
  return false
}

const FundsFinSwitchReinvestment = memo(FundsFinSwitchReinvestmentInner, areEqual)

export default FundsFinSwitchReinvestment
